export type DefaultProfileAvatar = {
  id: string;
  name: string;
  emoji: string;
  color: string;
};

/** Panda profile “default” animal avatars (emoji + gradient). */
export const DEFAULT_AVATARS: DefaultProfileAvatar[] = [
  {
    id: "panda",
    name: "Buddy",
    emoji: "🐼",
    color: "from-gray-200 to-gray-300",
  },
  {
    id: "tiger",
    name: "Hero",
    emoji: "🐅",
    color: "from-orange-200 to-orange-300",
  },
  {
    id: "lion",
    name: "Star",
    emoji: "🦁",
    color: "from-yellow-200 to-yellow-300",
  },
  {
    id: "elephant",
    name: "Giant",
    emoji: "🐘",
    color: "from-blue-200 to-blue-300",
  },
  {
    id: "monkey",
    name: "Clever",
    emoji: "🐵",
    color: "from-amber-200 to-amber-300",
  },
  { id: "fox", name: "Swift", emoji: "🦊", color: "from-red-200 to-red-300" },
  {
    id: "rabbit",
    name: "Hoppy",
    emoji: "🐰",
    color: "from-pink-200 to-pink-300",
  },
  {
    id: "bear",
    name: "Strong",
    emoji: "🐻",
    color: "from-amber-200 to-amber-300",
  },
  {
    id: "wolf",
    name: "Alpha",
    emoji: "🐺",
    color: "from-purple-200 to-purple-300",
  },
  { id: "eagle", name: "Sky", emoji: "🦅", color: "from-sky-200 to-sky-300" },
  {
    id: "deer",
    name: "Grace",
    emoji: "🦌",
    color: "from-emerald-200 to-emerald-300",
  },
  {
    id: "owl",
    name: "Wise",
    emoji: "🦉",
    color: "from-indigo-200 to-indigo-300",
  },
  {
    id: "parrot",
    name: "Chirpy",
    emoji: "🦜",
    color: "from-green-200 to-green-300",
  },
  {
    id: "penguin",
    name: "Cool",
    emoji: "🐧",
    color: "from-cyan-200 to-cyan-300",
  },
  {
    id: "koala",
    name: "Sleepy",
    emoji: "🐨",
    color: "from-stone-200 to-stone-300",
  },
  {
    id: "zebra",
    name: "Stripe",
    emoji: "🦓",
    color: "from-zinc-200 to-zinc-300",
  },
  {
    id: "giraffe",
    name: "Tall",
    emoji: "🦒",
    color: "from-yellow-100 to-yellow-200",
  },
  {
    id: "hippo",
    name: "Happy",
    emoji: "🦛",
    color: "from-slate-200 to-slate-300",
  },
  {
    id: "rhino",
    name: "Power",
    emoji: "🦏",
    color: "from-gray-100 to-gray-200",
  },
  {
    id: "crocodile",
    name: "Smiley",
    emoji: "🐊",
    color: "from-lime-200 to-lime-300",
  },
];
